export default "__VITE_ASSET__B4eA1vTi__"